import { render, staticRenderFns } from "./agendamentos.vue?vue&type=template&id=4855637e"
import script from "./agendamentos.vue?vue&type=script&lang=js"
export * from "./agendamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports